import { AxiosError } from 'axios';
import { generateQueryString, get } from '@/utils';
import { IUserGeolocation } from './types';

// GET api/users/:id/geolocations — PaginatedList standard (BE ordonează sentAt DESC).
type UserGeolocationsResponse = {
	items: IUserGeolocation[];
	pageNumber: number;
	totalPages: number;
	totalCount: number;
	hasPreviousPage: boolean;
	hasNextPage: boolean;
};

async function fetchUserGeolocations(
	userId: number | string,
	page: number,
	items: number,
	onResponse?: (totalPages: number, totalItems: number) => void
): Promise<IUserGeolocation[]> {
	try {
		// UI-ul e 0-based, BE-ul 1-based — conversia rămâne centralizată aici.
		const query = generateQueryString({ PageNumber: page + 1, PageSize: items });
		const res = await get(`api/users/${userId}/geolocations${query}`);
		const data = res.data as UserGeolocationsResponse;
		onResponse?.(data.totalPages || 1, data.totalCount || 0);
		return data.items || [];
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reușit să accesăm istoricul de locații.');
	}
}

export { fetchUserGeolocations };
